import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { listarProcessos, prazosVencendo } from '../services/api'
import Layout from './Layout'

const SBG = { aberto:'#E6F1FB', tramitando:'#FAEEDA', pendente:'#FAEEDA', concluido:'#EAF3DE', arquivado:'#F1EFE8', sobrestado:'#EEEDFE' }
const SC  = { aberto:'#185FA5', tramitando:'#854F0B', pendente:'#854F0B', concluido:'#3B6D11', arquivado:'#5F5E5A', sobrestado:'#534AB7' }
const SL  = { aberto:'Aberto', tramitando:'Tramitando', pendente:'Pendente', concluido:'Concluído', arquivado:'Arquivado', sobrestado:'Sobrestado' }

export function StatusBadge({ status }) {
  return (
    <span style={{ background:SBG[status]||'#f3f4f6', color:SC[status]||'#374151', padding:'2px 10px', borderRadius:99, fontSize:11, whiteSpace:'nowrap' }}>
      {SL[status]||status}
    </span>
  )
}

export default function Dashboard() {
  const navigate = useNavigate()
  const usuario = JSON.parse(localStorage.getItem('pg_usuario') || '{}')
  const [processos, setProcessos] = useState([])
  const [total, setTotal] = useState(0)
  const [prazos, setPrazos] = useState([])
  const [aba, setAba] = useState('recentes') // recentes | kanban | prazos

  useEffect(() => {
    listarProcessos({ limite: 20 }).then(r => {
      setProcessos(r.data.processos || [])
      setTotal(r.data.total || 0)
    }).catch(() => {})
    prazosVencendo().then(r => setPrazos(r.data || [])).catch(() => {})
  }, [])

  const contar = (s) => processos.filter(p => p.status === s).length

  const statusKanban = ['aberto','tramitando','pendente','concluido']

  function diasRestantes(prazo_em) {
    const diff = new Date(prazo_em) - new Date()
    const dias = Math.ceil(diff / (1000 * 60 * 60 * 24))
    if (dias < 0) return { texto: `${Math.abs(dias)}d vencido`, cor:'#dc2626', bg:'#fef2f2' }
    if (dias === 0) return { texto: 'Vence hoje', cor:'#dc2626', bg:'#fef2f2' }
    if (dias <= 2) return { texto: `${dias}d restante${dias>1?'s':''}`, cor:'#854F0B', bg:'#FAEEDA' }
    return { texto: `${dias}d restantes`, cor:'#3B6D11', bg:'#EAF3DE' }
  }

  return (
    <Layout>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h1 style={{ fontSize:18, fontWeight:500, margin:0 }}>Dashboard</h1>
          <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>Olá, {usuario.nome?.split(' ')[0]}!</div>
        </div>
        <button onClick={() => navigate('/processos/novo')}
          style={{ background:'#185FA5', color:'white', border:'none', borderRadius:8, padding:'8px 16px', fontSize:13, cursor:'pointer' }}>
          + Novo processo
        </button>
      </div>

      {prazos.length > 0 && (
        <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:12, padding:'12px 16px', marginBottom:20, display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:18 }}>⚠️</span>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:13, fontWeight:500, color:'#991b1b' }}>{prazos.length} processo{prazos.length>1?'s':''} com prazo vencendo em 7 dias</div>
            <div style={{ display:'flex', gap:8, marginTop:4, flexWrap:'wrap' }}>
              {prazos.slice(0,3).map(p => (
                <span key={p.id} onClick={() => navigate(`/processos/${p.id}`)} style={{ fontSize:11, fontFamily:'monospace', color:'#185FA5', cursor:'pointer', textDecoration:'underline' }}>
                  {p.numero}
                </span>
              ))}
              {prazos.length > 3 && <span style={{ fontSize:11, color:'#9ca3af' }}>+{prazos.length-3} mais</span>}
            </div>
          </div>
          <button onClick={() => setAba('prazos')} style={{ padding:'5px 10px', background:'#dc2626', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>
            Ver todos
          </button>
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:24 }}>
        {[
          { label:'Total', valor:total, onClick:() => navigate('/processos') },
          { label:'Abertos', valor:contar('aberto'), onClick:() => navigate('/processos?status=aberto') },
          { label:'Tramitando', valor:contar('tramitando'), onClick:() => navigate('/processos?status=tramitando') },
          { label:'Concluídos', valor:contar('concluido'), onClick:() => navigate('/processos?status=concluido') },
        ].map(s => (
          <div key={s.label} onClick={s.onClick} style={{ background:'#f3f4f6', borderRadius:8, padding:16, cursor:'pointer' }}
            onMouseEnter={e=>e.currentTarget.style.background='#e5e7eb'} onMouseLeave={e=>e.currentTarget.style.background='#f3f4f6'}>
            <div style={{ fontSize:12, color:'#6b7280', marginBottom:4 }}>{s.label}</div>
            <div style={{ fontSize:28, fontWeight:500 }}>{s.valor}</div>
          </div>
        ))}
      </div>

      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <div style={{ display:'flex', borderBottom:'1px solid #f3f4f6' }}>
          {[
            { key:'recentes', label:'Recentes' },
            { key:'kanban', label:'Kanban por status' },
            { key:'prazos', label:`Prazos ${prazos.length>0?`(${prazos.length})`:''}` },
          ].map(a => (
            <div key={a.key} onClick={() => setAba(a.key)} style={{
              padding:'12px 20px', fontSize:13, cursor:'pointer',
              fontWeight:aba===a.key?500:400,
              color:aba===a.key?'#185FA5':'#6b7280',
              borderBottom:aba===a.key?'2px solid #185FA5':'2px solid transparent',
              marginBottom:-0.5
            }}>{a.label}</div>
          ))}
          <div style={{ flex:1 }} />
          <div onClick={() => navigate('/processos')} style={{ padding:'12px 20px', fontSize:13, color:'#185FA5', cursor:'pointer' }}>Ver todos →</div>
        </div>

        {aba === 'recentes' && (
          processos.length === 0
            ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af', fontSize:14 }}>
                Nenhum processo ainda. <span style={{ color:'#185FA5', cursor:'pointer' }} onClick={() => navigate('/processos/novo')}>Abrir o primeiro →</span>
              </div>
            : processos.slice(0,10).map((p,i) => (
              <div key={p.id} onClick={() => navigate(`/processos/${p.id}`)} style={{
                display:'flex', alignItems:'center', gap:12, padding:'10px 20px',
                borderBottom:i<9?'1px solid #f3f4f6':'none', cursor:'pointer'
              }}
              onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
              onMouseLeave={e=>e.currentTarget.style.background='white'}>
                <div style={{ fontFamily:'monospace', fontSize:12, color:'#185FA5', minWidth:110 }}>{p.numero}</div>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:13, fontWeight:500 }}>{p.assunto}</div>
                  <div style={{ fontSize:11, color:'#9ca3af' }}>{p.req_nome}</div>
                </div>
                <StatusBadge status={p.status} />
              </div>
            ))
        )}

        {aba === 'kanban' && (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:0, padding:16 }}>
            {statusKanban.map(s => {
              const lista = processos.filter(p => p.status === s)
              return (
                <div key={s} style={{ padding:'0 8px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:10 }}>
                    <span style={{ background:SBG[s], color:SC[s], padding:'2px 8px', borderRadius:99, fontSize:11, fontWeight:500 }}>{SL[s]}</span>
                    <span style={{ fontSize:11, color:'#9ca3af' }}>{lista.length}</span>
                  </div>
                  {lista.length === 0
                    ? <div style={{ fontSize:12, color:'#d1d5db', textAlign:'center', padding:'20px 0' }}>Vazio</div>
                    : lista.map(p => (
                      <div key={p.id} onClick={() => navigate(`/processos/${p.id}`)} style={{
                        background:'white', border:'1px solid #e5e7eb', borderRadius:8, padding:'10px 12px',
                        marginBottom:8, cursor:'pointer', fontSize:12
                      }}
                      onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                      onMouseLeave={e=>e.currentTarget.style.background='white'}>
                        <div style={{ fontFamily:'monospace', color:'#185FA5', fontSize:11, marginBottom:3 }}>{p.numero}</div>
                        <div style={{ fontWeight:500, color:'#111', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.assunto}</div>
                        <div style={{ color:'#9ca3af', marginTop:2 }}>{p.req_nome}</div>
                      </div>
                    ))
                  }
                </div>
              )
            })}
          </div>
        )}

        {aba === 'prazos' && (
          prazos.length === 0
            ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af', fontSize:14 }}>Nenhum processo com prazo vencendo nos próximos 7 dias. ✅</div>
            : prazos.map((p,i) => {
              const d = diasRestantes(p.prazo_em)
              return (
                <div key={p.id} onClick={() => navigate(`/processos/${p.id}`)} style={{
                  display:'flex', alignItems:'center', gap:12, padding:'12px 20px',
                  borderBottom:i<prazos.length-1?'1px solid #f3f4f6':'none', cursor:'pointer'
                }}
                onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                onMouseLeave={e=>e.currentTarget.style.background='white'}>
                  <div style={{ fontFamily:'monospace', fontSize:12, color:'#185FA5', minWidth:110 }}>{p.numero}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13, fontWeight:500 }}>{p.assunto}</div>
                    <div style={{ fontSize:11, color:'#9ca3af' }}>{p.req_nome} · {p.setor_nome||'—'}</div>
                  </div>
                  <span style={{ background:d.bg, color:d.cor, padding:'3px 10px', borderRadius:99, fontSize:11, fontWeight:500, whiteSpace:'nowrap' }}>{d.texto}</span>
                </div>
              )
            })
        )}
      </div>
    </Layout>
  )
}
